<template>
    <div class="main-content">

        <!-- 条件查询 -->
        <div >
            <el-form :inline="true" :model="searchForm" ref="searchForm" class="form-content">
                <el-row :gutter="20" class="slt" :style="{justifyContent:contents.searchBoxPosition=='1'?'flex-start':contents.searchBoxPosition=='2'?'center':'flex-end'}">

                    <el-form-item label="煤炭名称" prop="cocalName">
                        <el-input prefix-icon="el-icon-search" v-model="searchForm.cocalName" placeholder="煤炭名称" clearable style="width:200px"></el-input>
                    </el-form-item>
                    <el-form-item label="煤源类型" prop="cocalType">
                        <el-select v-model="searchForm.cocalType" placeholder="煤源类型" style="width:200px">
                            <el-option v-for="(item,i) in cocalTypeList" :key="i" :label="item.indexName" :value="item.indexName" clearable></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否破碎" prop="isBroken">
                        <el-select v-model="searchForm.isBroken" placeholder="是否破碎" style="width:200px">
                            <el-option label="是" value="是" clearable></el-option>
                            <el-option label="否" value="否" clearable></el-option>
                        </el-select>
                    </el-form-item>
                    <br/>
                    <el-form-item label="热值">
                        <el-input prefix-icon="el-icon-search" v-model="searchForm.startHots" placeholder="起" clearable style="width:100px;padding-right:5px"></el-input>到
                        <el-input prefix-icon="el-icon-search" v-model="searchForm.endHots" placeholder="至" clearable style="width:100px"> </el-input>
                    </el-form-item>
                    <el-form-item label="硫分值">
                        <el-input prefix-icon="el-icon-search" v-model="searchForm.startLiufen" placeholder="起" clearable style="width:100px;padding-right:5px"></el-input>到
                        <el-input prefix-icon="el-icon-search" v-model="searchForm.endLiufen" placeholder="至" clearable style="width:100px"> </el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="success" @click="search()">查询<i class="el-icon-search el-icon--right"/></el-button>
                        <el-button type="success" @click="reset()">重置<i class="el-icon-refresh el-icon--right"/></el-button>
                    </el-form-item>
                </el-row>
                <el-row class="ad" :style="{justifyContent:contents.btnAdAllBoxPosition=='1'?'flex-start':contents.btnAdAllBoxPosition=='2'?'center':'flex-end'}">
                    <el-form-item>
                        <el-button v-show="isEmporer('新增')"  type="success"
                                   icon="el-icon-plus"  @click="addOrUpdateHandler()"
                                   :disabled="totalPage>20"

                        >新增</el-button>
                        <el-button v-show="isEmporer('导入')" type="success"  icon="el-icon-top"  @click="openImportDialog()">导入</el-button>
                        <el-button v-show="isEmporer('导出')" type="success"  icon="el-icon-top" >
                            <a  style="color:white" :href="url+'cocalTemplateOwner/download?companyId='+companyId">导出数据</a>
                        </el-button>
                      <el-button v-show="isEmporer('删除')" type="danger" icon="el-icon-plus" @click="mulDel" :disabled="this.dataListSelections.length<=0">批量删除</el-button>

                      <!--<el-button
                              :disabled="dataListSelections.length <= 0"
                              type="danger"
                              icon="el-icon-delete"
                              @click="deleteHandler()"
                      >删除</el-button>-->
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="table-content">
                <el-table class="tables" :size="contents.tableSize" :show-header="contents.tableShowHeader"
                          :header-row-style="headerRowStyle" :header-cell-style="headerCellStyle"
                          :border="contents.tableBorder"
                          :fit="contents.tableFit"
                          :stripe="contents.tableStripe"
                          :row-style="rowStyle"
                          :cell-style="cellStyle"
                          :style="{width: '100%',fontSize:contents.tableContentFontSize,color:contents.tableContentFontColor}"
                          :data="dataList"
                          v-loading="dataListLoading"
                          @sort-change="hadleSort"
                          height="800px"
                          @selection-change="handleSelectionChange"
                >
                    <el-table-column type="selection" width="50" fixed="left"></el-table-column>
                    <el-table-column label="索引" v-if="contents.tableIndex" type="index" width="50" fixed />
                    <!--<el-table-column  :sortable="contents.tableSortable" align="center" prop="orgType"  label="类型" fixed></el-table-column>-->
                    <el-table-column  :sortable="contents.tableSortable" align="center" prop="companyName"  label="所属公司" fixed width="150"></el-table-column>
                    <el-table-column  :sortable="contents.tableSortable" align="center" prop="cocalName"  label="煤炭名称" fixed width="200"></el-table-column>
                    <el-table-column  :sortable="contents.tableSortable" align="center" prop="personName1"  label="联系人" fixed></el-table-column>
                    <el-table-column  :sortable="contents.tableSortable" align="center" prop="mobile1"  label="联系电话" fixed></el-table-column>
                    <el-table-column  :sortable="contents.tableSortable" align="center" prop="cocalType"  label="煤种类型" fixed></el-table-column>
                    <el-table-column  :sortable="contents.tableSortable" align="center" prop="hots"  label="热值" sortable="custom"></el-table-column>
                    <el-table-column  :sortable="contents.tableSortable" align="center" prop="liufen"  label="硫分"></el-table-column>
                    <el-table-column  :sortable="contents.tableSortable" align="center" prop="unitPrice"  label="含税单价" sortable="custom" width="130"></el-table-column>
                    <el-table-column  :sortable="contents.tableSortable" align="center" prop="isBroken"  label="是否破碎"></el-table-column>
                    <el-table-column  :sortable="contents.tableSortable" align="center" prop="stock"  label="库存"></el-table-column>
                    <el-table-column  :sortable="contents.tableSortable" align="center" prop="arriveStation"  label="到场地"></el-table-column>
                    <el-table-column  :sortable="contents.tableSortable" align="center" prop="hsPrice"  label="含税运费" sortable="custom" width="100"></el-table-column>
                    <el-table-column  :sortable="contents.tableSortable" align="center" prop="stationPrice"  label="场地费" sortable="custom" width="90"></el-table-column>
                    <el-table-column width="300" :align="contents.tableAlign"
                                     header-align="center"  fixed="right"
                                     label="操作">
                        <template slot-scope="scope">
                            <el-button v-show="isEmporer('明细')" type="success" icon="el-icon-tickets" size="mini" @click="addOrUpdateHandler(scope.row,'info')">明细</el-button>
                            <el-button v-show="isEmporer('编辑')" type="primary" icon="el-icon-edit" size="mini" @click="addOrUpdateHandler(scope.row)">修改</el-button>
                            <el-button v-show="isEmporer('删除')" type="danger" icon="el-icon-delete" size="mini" @click="deleteHandler(scope.row.id)">删除</el-button>

                        </template>
                    </el-table-column>
                </el-table>
              <el-pagination
                  @size-change="sizeChangeHandle"
                  @current-change="currentChangeHandle"
                  :current-page="pageIndex"
                  :page-sizes="[10, 20, 30, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalPage">
              </el-pagination>

            </div>
        </div>
        <add-or-update :show="addOrUpdateFlag" :rowData="rowData" v-on:listenToChildEvent="closeDialog"></add-or-update>
        <cocal-import :show="importShow" v-on:listenToChildEvent="closeImportDialog"></cocal-import>
    </div>
</template>
<script>
    import AddOrUpdate from "./add-or-update";
    import cocalImport from "./cocal-import";
    import styleJs from "../../../utils/style.js";
    import base from '@/utils/base';
    import utilsJs, {getYearFormat,getMonthFormat,getDateFormat,getDatetimeFormat} from "../../../utils/utils.js";

    export default {
        data() {
            return {
                url:base.get().url,
                importShow:false,
                //打印结束
                searchForm: {
                    key: ""
                },
                sessionTable : "",//登录账户所在表名
                role : "",//权限
                userId:"",//当前登录人的id
                //级联表下拉框搜索条件
                //当前表下拉框搜索条件
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                showFlag: true,
                addOrUpdateFlag:false,
                contents:null,
                layouts: '',
                rowData: {},
                cocalTypeList:[],
                sort:'id',
                order:'desc',
                selectBtnStr:'',
                menuBtnList:[],
                companyId:'',
            };
        },
        created() {
            let btnList = this.$storage.getMenuBtnListByMenuName("cocalTemplateOwner");
            this.contents = styleJs.listStyle();
            this.initBtnList();
            this.init();
            this.initCocalTypeList();
            this.getDataList();

            this.selectBtnStr = btnList;
            this.companyId = this.$storage.get("companyId");
        },
        mounted() {
            //获取当前登录用户的信息
            this.sessionTable = this.$storage.get("sessionTable");
            this.role = this.$storage.get("role");
            this.userId = this.$storage.get("userId");

        },
        filters: {
            htmlfilter: function (val) {
                return val.replace(/<[^>]*>/g).replace(/undefined/g,'');
            }
        },
        components: {
            AddOrUpdate,
            cocalImport
        },
        computed: {
        },
        methods: {
          mulDel(){
            let ids = this.dataListSelections.map(item => {
              return item.id
            })
            this.$confirm(`确定对进行批量删除操作?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$http({
                url: 'cocalTemplateOwner/delete',
                method: 'post',
                data: ids
              }).then(({data}) => {
                if (data && data.code === 0) {
                  this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      this.getDataList();
                    }
                  })
                } else {
                  this.$message.error(data.msg);
                }
              })
            })
          },
          handleSelectionChange(val){
            this.dataListSelections = val;
          },
            // 表格
            rowStyle({row, rowIndex}) {
                if (rowIndex % 2 == 1) {
                    if (this.contents.tableStripe) {
                        return {color: this.contents.tableStripeFontColor}
                    }
                } else {
                    return ''
                }
            },
            cellStyle({row, rowIndex}) {
                if (rowIndex % 2 == 1) {
                    if (this.contents.tableStripe) {
                        return {backgroundColor: this.contents.tableStripeBgColor}
                    }
                } else {
                    return ''
                }
            },
            headerRowStyle({row, rowIndex}) {
                return {color: this.contents.tableHeaderFontColor}
            },
            headerCellStyle({row, rowIndex}) {
                return {backgroundColor: this.contents.tableHeaderBgColor}
            },
            // 表格按钮
            contentTableBtnStyleChange() {
            },
            // 分页
            contentPageStyleChange() {
                let arr = []
                if (this.contents.pageTotal) arr.push('total')
                if (this.contents.pageSizes) arr.push('sizes')
                if (this.contents.pagePrevNext) {
                    arr.push('prev')
                    if (this.contents.pagePager) arr.push('pager')
                    arr.push('next')
                }
                if (this.contents.pageJumper) arr.push('jumper')
                this.layouts = arr.join()
                this.contents.pageEachNum = 10
            },

            init() {
            },
            hadleSort({ column, prop, order }){
                this.sort = prop.replace(/([A-Z])/g,"_$1").toLowerCase();
                this.order = order.replace("ending","");
                this.getDataList();
            },
            search() {
                this.pageIndex = 1;
                this.getDataList();
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true;
                let params = {
                    page: this.pageIndex,
                    limit: this.pageSize,
                    sort: this.sort,
                    order:this.order
                }
                if (this.searchForm.cocalName!= '' && this.searchForm.cocalName!= undefined) {
                    params['cocalName'] = '%' + this.searchForm.cocalName + '%'
                }
                if (this.searchForm.cocalType!= '' && this.searchForm.cocalType!= undefined) {
                    params['cocalType'] = '%' + this.searchForm.cocalType + '%'
                }
                if (this.searchForm.isBroken!= '' && this.searchForm.isBroken!= undefined) {
                    params['isBroken'] = '%' + this.searchForm.isBroken + '%'
                }
                if (this.searchForm.startHots!= '' && this.searchForm.startHots!= undefined) {
                    params['startHots'] = this.searchForm.startHots;
                }
                if (this.searchForm.endHots!= '' && this.searchForm.endHots!= undefined) {
                    params['endHots'] = this.searchForm.endHots ;
                }
                if (this.searchForm.startLiufen!= '' && this.searchForm.startLiufen!= undefined) {
                    params['startLiufen'] = this.searchForm.startLiufen;
                }
                if (this.searchForm.endLiufen!= '' && this.searchForm.endLiufen!= undefined) {
                    params['endLiufen'] = this.searchForm.endLiufen ;
                }
                this.$http({
                    url: "cocalTemplateOwner/page",
                    method: "get",
                    params: params
                }).then(({data}) => {
                    if(data && data.code === 0){
                        this.dataList = data.data.list;
                        this.totalPage = data.data.total;
                    }else{
                        this.dataList = [];
                        this.totalPage = 0;
                    }
                    this.dataListLoading = false;
                });

                //查询级联表搜索条件所有列表
                //查询当前表搜索条件所有列表
            },
            //每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandler(val) {
                this.dataListSelections = val;
            },
            // 添加/修改
            addOrUpdateHandler( row,type) {
                this.addOrUpdateFlag = true;
                if (row!=undefined){
                    row.type = type;
                    this.rowData = row;
                }
            },
            // 删除
            deleteHandler(id) {
                var ids = id ? [Number(id)] : this.dataListSelections.map(item => {
                    return Number(item.id);
                });

                this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.$http({
                        url: "cocalTemplateOwner/delete",
                        method: "post",
                        data: ids
                    }).then(({data}) => {
                        if(data && data.code === 0){
                            this.$message({
                                message: "操作成功",
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.search();
                                }
                            });
                        }else{
                            this.$message.error(data.msg);
                        }
                    });
                });
            },
            closeDialog(){
                this.addOrUpdateFlag = false;
                this.getDataList();
            },
            formatDate(dateStr){
                let date = new Date(dateStr);
                return date.toLocaleString();
            },
            closeImportDialog(){
                this.importShow = false;
                this.getDataList();
            },
            openImportDialog(){
                this.importShow = true;
            },
            initCocalTypeList(){
                let params = {
                    page: 1,
                    limit: 30,
                    sort: 'id',
                }
                params['dicCode'] = "cocal_type"//编码名字
                params['dicName'] = "煤种类型",//汉字名字
                this.$http({
                    url: "dictionary/page",
                    method: "get",
                    params: params
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.cocalTypeList = data.data.list;
                    }
                });
            },
            reset(){
                this.$refs['searchForm'].resetFields();
                this.sort = 'id';
                this.order = 'desc';
                this.searchForm.startHots = '';
                this.searchForm.endHots = '';
                this.searchForm.startLiufen = '';
                this.searchForm.endLiufen = '';

            },

            initBtnList(){
                let params = {
                    page: this.pageIndex,
                    limit: 30,
                    sort: 'id',
                }
                //本表的
                params['dicCode'] = "menu_types"//编码名字
                params['dicName'] = "按钮类型",//汉字名字
                this.$http({
                    url: "dictionary/page",
                    method: "get",
                    params: params
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.menuBtnList = data.data.list;
                    }
                });
            },
            isEmporer(btnName){
                let menuBtn = this.menuBtnList.find(item=> item.indexName==btnName);
                return this.selectBtnStr.indexOf(menuBtn.codeIndex)==-1?false:true;
            }
        },

    };
</script>
<style lang="scss" scoped>
    .main-content {
        background: #fff;
        border-radius: 6px;
        padding: 20px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    }

    .slt {
        margin: 0 !important;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 0;
        padding-bottom: 12px;
        border-bottom: 1px solid #f0f0f0;
    }

    .ad {
        margin: 0 !important;
        display: flex;
        align-items: center;
        padding: 12px 0;
    }

    .pages {
        & /deep/ el-pagination__sizes {
            & /deep/ el-input__inner {
                height: 28px;
                line-height: 28px;
            }
        }
    }

    .el-button+.el-button {
        margin-left: 8px;
    }

    .form-content {
        background: transparent;
    }

    .table-content {
        background: transparent;
    }

    /* 搜索区按钮 */
    .form-content .slt .el-button--success {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
        color: #fff;
        border-radius: 4px;
        padding: 10px 20px;
        font-size: 14px;
        transition: all 0.25s ease;

        &:hover {
            background-color: #2b5797;
            border-color: #2b5797;
        }
    }

    /* 新增按钮 */
    .form-content .ad .el-button--success {
        background-color: var(--publicSubColor);
        border-color: var(--publicSubColor);
        color: #fff;
        border-radius: 4px;
        padding: 10px 20px;
        font-size: 14px;
        transition: all 0.25s ease;

        &:hover {
            background-color: #c9602d;
            border-color: #c9602d;
        }
    }

    /* 表格样式 */
    .tables {
        width: 100%;
        border-radius: 4px;
        overflow: hidden;

        & /deep/ .el-table__header th {
            background-color: #f5f7fa;
            color: #303133;
            font-weight: 600;
            font-size: 14px;
        }

        & /deep/ .el-table__body tr {
            background-color: #fff !important;
            color: #606266 !important;
        }

        & /deep/ .el-table__body tr.el-table__row--striped td {
            background: #fafafa;
        }

        & /deep/ .el-table__body tr.el-table__row--striped {
            background-color: #fafafa !important;
            color: #606266 !important;
        }

        & /deep/ .el-table__body tr:hover > td {
            background-color: rgba(58, 110, 165, 0.06) !important;
            color: #303133 !important;
        }

        /* 表格操作按钮 */
        & /deep/ .el-button--success {
            background-color: #67c23a;
            border-color: #67c23a;
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #85ce61;
                border-color: #85ce61;
            }
        }

        & /deep/ .el-button--primary {
            background-color: var(--publicMainColor);
            border-color: var(--publicMainColor);
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #2b5797;
                border-color: #2b5797;
            }
        }

        & /deep/ .el-button--danger {
            background-color: #f56c6c;
            border-color: #f56c6c;
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #f78989;
                border-color: #f78989;
            }
        }

        & /deep/ .el-button--warning {
            background-color: #e6a23c;
            border-color: #e6a23c;
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #ebb563;
                border-color: #ebb563;
            }
        }

        & /deep/ .el-button {
            margin: 4px;
        }
    }

    /* 分页 */
    .pagination-content {
        margin-top: 20px;
        padding: 10px 0;
    }

    /* 封面图片 */
    .tables /deep/ img {
        border-radius: 6px;
        object-fit: cover;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
</style>


